// extracted by mini-css-extract-plugin
export default {"fullRow":"FiltersCard_fullRow__hTT1n"};